import Alert from "@mui/material/Alert";

const NoData = ({ message = "Data Unavailable." }) => (
  <Alert severity="info" variant="outlined">
    {message}
  </Alert>
);

export default NoData;
